import React from "react";
import TopHeader from "../../components/TopHeader";
import Footer from "../../components/Footer";

function MentionsLegales() {
  return (
    <>
      <TopHeader btn={true}/>
      <div className="container mt-40 mb-80">
        <div className="col-md-8 mx-auto">
          <h2 className="grey500">Mentions légales</h2>
          <p className="body mt-14 grey66 bold500">
            <p>Le site web twyny.com est édité et exploité par Eppox SAS.</p>

            <p>
              {" "}
              La marque TWYNY est une marque déposée dans l’Union Européenne.
            </p>
          </p>
          <div className="mt-40">
            <h4 className="grey500 mt-24">Contact</h4>
            <p className="body mt-24 bold500">
            Adresse postale : 78, Av. des Champs-Elysées, Bureau 326, 75008 Paris, France
            </p>
            <p className="body mt-14 grey66 bold500">
              Courriel :{" "}
              <a
                href="mailto:support@twyny.com"
                className="text-decoration-none"
              >
                support@twyny.com
              </a>
            </p>
            <h4 className="grey500 mt-24">Eppox SAS</h4>
            <p className="body mt-14 grey66 bold500">
              <p>Capital social : 50 000 €</p>
              <p>RCS Paris : 878 115 856</p>

              <p> N° TVA intracommunautaire : FR46 878 115 856</p>

              <p>
                Le site twyny.com a fait l'objet d'une déclaration à la CNIL
                enregistrée sous le N° ............
              </p>

              <p>Copyright 2025, all rights reserved</p>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MentionsLegales;
